<template>
  <PageContentLayoutOnly headerColor="#fafafa">
    <div>
      <div class="pb-3" v-if="(mailingCommunicationID || communicationID) <= 0">
        <b-notification type="is-info is-light" has-icon aria-close-label="Close notification">
          <div>
            Please save General Information Prior to composing the Email message
          </div>
        </b-notification>
      </div>
      <div v-else>
        <div class="pb-3">
          <button
            @click.prevent="finalizeMessageFromState(true)"
            :disabled="!emailMessage && !emailMessageSubject"
            class="button is-primary is-rounded"
          >
            Save
          </button>
        </div>
        <div scheduling class="notification headerColor" v-if="formData">
          <div class="box is-12">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
              <transition name="fade" mode="out-in" appear>
                <form @submit.prevent="handleSubmit(onFormSubmit)" class="form">
                  <fieldset>
                    <div>
                      <MessageComposer
                        message=""
                        :finalizeMessage="finalizeMessage"
                        :saveMessageForFinalize="saveMessageForFinalize"
                        :showPreview="true"
                        :showSendTestEmail="true"
                        :showAttachments="true"
                        :processPreview="processFinalPreview"
                        :processSendTestEmail="processSendTestEmail"
                        :processAttachments="processAttachments"
                        :composedText="emailMessage"
                        :composedSubject="emailMessageSubject"
                        :handleImageAdded="handleImageAdded"
                        :handleImageRemoved="handleImageRemoved"
                        :isReadOnly="hasReadonly"
                        :isOnChanged="true"
                      />
                    </div>
                    <div>
                      <div class="force-center subtitle pt-6 pb-5">
                        File Preview
                      </div>
                      <div
                        class="pb-5"
                        style="text-align: left !important;"
                        v-if="typeof (composedSubject === 'string')"
                        v-html="composedSubject"
                      ></div>
                      <div
                        class="pb-5"
                        style="text-align: left !important;"
                        v-if="typeof (composedText === 'string')"
                        v-html="composedText"
                      ></div>
                    </div>
                  </fieldset>
                  <fieldset>
                    <ValidationProvider vid="providerErrors" v-slot="{ errors }">
                      <div class="field">
                        <span>{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </fieldset>
                </form>
              </transition>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </PageContentLayoutOnly>
</template>

<script>
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapState, mapGetters } from 'vuex'
import { data } from './keys/data'
import { methods } from './keys/methods'
import MessageComposer from '@/pages/Shared/mailingCommunications/components/communicationModal/keys/MessageComposer'

export default {
  name: 'EmailCommunicationMessage',
  components: {
    ValidationObserver,
    ValidationProvider,
    PageContentLayoutOnly,
    MessageComposer
  },

  data,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('user', ['authUser']),
      ...mapGetters('communication', [
        'supportMailDelivery',
        'supportEmailDelivery',
        'supportSMSDelivery',
        'isLegalCommunication',
        'mailingTypeID',
        'mailingType',
        'emailMessage',
        'emailMessageSubject',
        'mailingCommunicationID',
        'communicationDescription',
        'selectedDeliveryOwnerIDs',
        'selectedDeliveryOwners',
        'deliveryDate',
        'isFullDuplex',
        'isColor',
        'hasReadonly'
      ])
    })
  },

  mounted() {
    this.loadFromState()
  },

  watch: {
    hoaId() {
      this.reload()
    }
  },

  methods,

  i18n: {
    messages: {
      en: {
        composeEmail: { title: 'Enter Email Communication' }
      }
    }
  }
}
</script>

<style lang="scss">
#update-work-order .my-grid-class {
  height: 400px;
}

#update-work-order tbody {
  min-height: 100px !important;
  overflow: auto !important;
}
</style>
